import type { BackendConfig } from './config'
import type { AIService } from './ports/ai'
import type { RagService } from './ports/rag'
import type { PromptStore } from './ports/prompts'
import type { SystemPromptStore } from './ports/system-prompts'
import type { SpeechService } from './ports/speech'
import type { SkillStore } from './ports/skills'
import { createHttpBackend } from './adapters/http'

/** The capabilities the add-ins talk to. Adapters: HTTP (real) or mock (dev/tests). */
export interface BackendClient {
  ai: AIService
  rag: RagService
  prompts: PromptStore
  systemPrompts: SystemPromptStore
  speech: SpeechService
  skills: SkillStore
}

/** Real client against the backend REST/SSE API. */
export function createBackendClient(config: BackendConfig): BackendClient {
  return createHttpBackend(config)
}

export { createMockBackendClient, PROMPT_SEED, SYSTEM_PROMPT_SEED } from './adapters/mock'
export type { MockSeed } from './adapters/mock'
